import React from 'react';
import './style.scss';
import { usePersonalAccountOpen, PersonalAccountOpenPages} from './hooks';

export const PersonalAccountOpen = () => {
  const { personalAccountOpenPageType, SwitchPage } = usePersonalAccountOpen();

  return (
    <>
      <div className="accountOpen">{SwitchPage(personalAccountOpenPageType)}</div>
    </>
  );
};
